import React from 'react';

import { Grid } from 'semantic-ui-react';
import PaymentCard from './PaymentCard';
import { paymentTypes } from '../data/payment-types';

export default ({ onPlanSelected }) => (
  <React.Fragment>
    <Grid
      className="modal-content payment-cards"
      stackable
      columns={paymentTypes.length}
      verticalAlign="top"
    >
      {paymentTypes.map(paymentType => (
        <Grid.Column className="payment-column" key={paymentTypes.indexOf(paymentType)}>
          <PaymentCard
            {...paymentType}
            onPlanSelected={onPlanSelected}
            index={paymentTypes.indexOf(paymentType)}
          />
        </Grid.Column>
      ))}
    </Grid>
  </React.Fragment>
);
